import { isNil } from 'lodash-es';

export interface ApiHttpError {
  description?: string;
  statusCode: number;
  message: string;
  error: string;
}

export function isApiHttpError(obj: unknown): obj is ApiHttpError {
  /**
   * Checks if an object is of type `ApiHttpError`.
   *
   * @param obj - The object to be checked if it is of type `ApiHttpError`.
   * @returns Returns `true` if the object is of type `ApiHttpError`, and `false` otherwise.
   *
   */
  const { error, message, statusCode } = (obj as ApiHttpError) ?? {};
  return !isNil(statusCode) && !isNil(message) && !isNil(error);
}
